import { useNavigate } from 'react-router-dom';
import { Send } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip';
import { prefetchRoute } from '@/lib/lazyRoute';
import { cn } from '@/lib/utils';

interface SendButtonProps {
  isCollapsed: boolean;
  onNavigate?: () => void;
}

const prefetchSendPage = () => prefetchRoute('/faxes/send');

export function SendButton({ isCollapsed, onNavigate }: SendButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    onNavigate?.();
    navigate('/faxes/send');
  };

  return (
    <div className={cn('px-4 mb-2', isCollapsed && 'px-2')}>
      {isCollapsed ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="default"
              size="icon"
              className="w-full"
              onClick={handleClick}
              onMouseEnter={prefetchSendPage}
              onFocus={prefetchSendPage}
            >
              <Send className="h-5 w-5" />
              <span className="sr-only">Send</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">Send</TooltipContent>
        </Tooltip>
      ) : (
        <Button
          variant="default"
          className="w-full h-14 text-base justify-center"
          onClick={handleClick}
          onMouseEnter={prefetchSendPage}
          onFocus={prefetchSendPage}
        >
          <Send className="h-5 w-5" />
          <span>Send</span>
        </Button>
      )}
    </div>
  );
}
